import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { applySnapshot, cast, getParent, types } from 'mobx-state-tree';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { api } from 'src/api';
import { IS_PAYMENT_METHOD, AMOUNT_TYPE, TRANSACTION_TYPESV2 } from 'src/constants/payments';
import { createAsync } from 'src/utils/asyncModel';
import { toJS } from 'mobx';
const selectedPropertyPaymentSetup = self => {
  var _getParent$homeDashbo;
  return (_getParent$homeDashbo = getParent(self).homeDashboardStore.getCurrentCompany) === null || _getParent$homeDashbo === void 0 || (_getParent$homeDashbo = _getParent$homeDashbo.selectedPropertyDetails()) === null || _getParent$homeDashbo === void 0 ? void 0 : _getParent$homeDashbo.details.paymentSetup;
};
const deletePaymentMethodAsync = createAsync(body => {
  return async function deletePaymentMethod(options) {
    const resp = await api.Payment.deletePaymentMethod(body, options);
    return resp;
  };
});
const getStripeProductsAsync = createAsync(() => {
  return async function getStripeProducts(options) {
    const resp = await api.Payment.getStripeProducts(options);
    this.setStripeProducts(resp.response);
    return resp;
  };
});
const getAccountBalanceAsync = createAsync(body => {
  return async function getAccountBalance(options) {
    var _currentStatement;
    const respBalance = await api.Payment.getAccountBalance(body, options);
    const _getParent = getParent(this),
      statement = _getParent.statement;
    await statement.getAccountStatementsPreviewAsync.run({
      accountId: body.accountId
    });
    const statements = statement.accountStatementsPreview;
    let currentStatement = statements.find(s => s.isRegularStatement);

    // ? in cases where no regular statements
    if (!currentStatement) currentStatement = statements.find(s => !s.isRegularStatement);
    const respAccountStatement = !currentStatement ? {} : await api.Statement.statement((_currentStatement = currentStatement) === null || _currentStatement === void 0 ? void 0 : _currentStatement.statementId, options);
    this.setResidentBalance(_objectSpread(_objectSpread({}, respBalance.response), respAccountStatement.response));
    return _objectSpread(_objectSpread({}, respBalance.response), respAccountStatement.response);
  };
});
const getAutopayMethodAsync = createAsync(body => {
  return async function getAutopayMethod(options) {
    const resp = await api.Payment.getAutopayMethod(body, options);
    const _getParent2 = getParent(this),
      payment = _getParent2.payment;
    if (resp) payment.setAutopayMethodAfterLoad(resp);
    return resp;
  };
});
const applyCouponAsync = createAsync(body => {
  return async function applyCoupon(options) {
    const resp = await api.Payment.applyCoupon(body, options);
    return resp;
  };
});
const getCouponsAsync = createAsync(body => {
  return async function getCoupons(options) {
    const resp = await api.Payment.getCoupons(body, options);
    const _getParent3 = getParent(this),
      payment = _getParent3.payment;
    payment.setCouponsAfterLoad(resp);
    return resp;
  };
});
const setAutopayMethodAsync = createAsync(body => {
  return async function setAutopayMethod(options) {
    const resp = await api.Payment.setAutopayMethod(body, options);
    return resp;
  };
});
const errorPaymentMethod = [{
  brand: 'Error',
  id: 'Error',
  isVerified: true,
  isDefault: true,
  last4: 'Error',
  paymentMethodType: null,
  assignedPropertyIds: null,
  verificationDaysLeft: null,
  verificationUrl: null,
  isFailed: false
}];
const getPaymentMethodsAsync = createAsync(body => {
  return async function getPaymentMethods(options) {
    const _getParent4 = getParent(this),
      payment = _getParent4.payment;
    const _getParent5 = getParent(this),
      company = _getParent5.company;
    localStorage.setItem(IS_PAYMENT_METHOD, 'true');
    payment.setPaymentMethodsAfterLoad(errorPaymentMethod);
    const resp = await api.Payment.getPaymentMethods(body, options);
    if (resp.response && resp.response.length === 0 && !company.companyFeatureStore.isAppfolio) {
      localStorage.setItem(IS_PAYMENT_METHOD, 'false');
    }
    payment.setPaymentMethodsAfterLoad(resp);
    return resp;
  };
});

// COPY of "getPaymentMethodsAsync"
// Needed to fix display of verification error notification

const getPaymentMethodsV2Async = createAsync(body => {
  return async function getPaymentMethods(options) {
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const _getParent6 = getParent(this),
      payment = _getParent6.payment;
    const resp = await api.Payment.getPaymentMethods(body, options);
    payment.setPaymentMethodsAfterLoad(resp);
    if (applyToHomeDashboard) {
      var _selectedPropertyPaym;
      (_selectedPropertyPaym = selectedPropertyPaymentSetup(this)) === null || _selectedPropertyPaym === void 0 || _selectedPropertyPaym.setPaymentMethodsAfterLoad(resp);
    }
    return resp;
  };
});
const getPaymentMethodsHomeDashboardAsync = createAsync(body => {
  return async function getPaymentMethods(options) {
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const resp = await api.Payment.getPaymentMethods(body, options);
    if (applyToHomeDashboard) {
      var _selectedPropertyPaym2;
      (_selectedPropertyPaym2 = selectedPropertyPaymentSetup(this)) === null || _selectedPropertyPaym2 === void 0 || _selectedPropertyPaym2.setPaymentMethodsAfterLoad(resp);
    }
    return resp;
  };
});
const getPaymentSummaryAsync = createAsync(body => {
  return async function getPaymentSummary(options) {
    const resp = await api.Payment.getPaymentSummary(body, options);
    const _getParent7 = getParent(this),
      payment = _getParent7.payment;
    payment.setPaymentSummaryAfterLoad(resp);
    return resp;
  };
});
const getPublicKeyAsync = createAsync(body => {
  return async function getPublicKey(options) {
    const resp = await api.Payment.getPublicKey(body, options);
    const _getParent8 = getParent(this),
      payment = _getParent8.payment;
    payment.setPublicKeyAfterLoad(resp);
    return resp;
  };
});
const getSetupIntentAsync = createAsync(body => {
  return async function getAddBillingCycle(options) {
    const resp = await api.Payment.getSetupIntent(body, options);
    return resp;
  };
});
const getSetupIntentWithAutopayAsync = createAsync(body => {
  return async function getAddBillingCycle(options) {
    const resp = await api.Payment.getSetupIntentWithAutopay(body, options);
    return resp;
  };
});
const getSetupIntentWithSubscriptionAsync = createAsync(body => {
  return async function getAddBillingCycle(options) {
    const resp = await api.Payment.getSetupIntentWithSubscription(body, options);
    const _getParent9 = getParent(this),
      payment = _getParent9.payment;
    payment.setSetupIntentId(resp);
    return resp;
  };
});
const getSubscriptionAsync = createAsync(body => {
  return async function getSubscription(options) {
    const resp = await api.Payment.getSubscription(body, options);
    const _getParent0 = getParent(this),
      payment = _getParent0.payment;
    payment.setSubscriptionAfterLoad(resp);
    return resp;
  };
});
const postPayoutAchDirectDepositAsync = createAsync(body => {
  return async function postPayoutAchDirectDeposit(options) {
    const resp = await api.Payment.postPayoutACHDirectDeposit(body, options);
    return resp;
  };
});
const postSetupIntentWithCouponAsync = createAsync(body => {
  return async function postSetupIntentWithCoupon(options) {
    const resp = await api.Payment.postSetupIntentWithCoupon(body, options);
    return resp;
  };
});
const putPayoutAchDirectDepositAsync = createAsync(body => {
  return async function putPayoutAchDirectDeposit(options) {
    const resp = await api.Payment.putPayoutACHDirectDeposit(body, options);
    return resp;
  };
});
const getPayoutAchDirectDepositAsync = createAsync(body => {
  return async function getPayoutAchDirectDeposit(options) {
    const resp = await api.Payment.getPayoutACHDirectDeposit(body, options);
    return resp;
  };
});
const getCompanyAchDirectDepositsListAsync = createAsync(body => {
  return async function getCompanyAchDirectDepositsList(options) {
    const resp = await api.Payment.getCompanyPayoutACHDirectDepositsList(body, options);
    return resp;
  };
});
const postPayoutRegularCheckAsync = createAsync(body => {
  return async function postPayoutRegularCheck(options) {
    const resp = await api.Payment.postPayoutRegularCheck(body, options);
    return resp;
  };
});
const putPayoutRegularCheckAsync = createAsync(body => {
  return async function putPayoutRegularCheck(options) {
    const resp = await api.Payment.putPayoutRegularCheck(body, options);
    return resp;
  };
});
const getPayoutRegularCheckAsync = createAsync(body => {
  return async function getPayoutRegularCheck(options) {
    const resp = await api.Payment.getPayoutRegularCheck(body, options);
    return resp;
  };
});
const getCompanyPayoutRegularChecksListAsync = createAsync(body => {
  return async function getCompanyPayoutRegularChecksList(options) {
    const resp = await api.Payment.getCompanyPayoutRegularChecksList(body, options);
    return resp;
  };
});
const getCompanyPayoutMethodsAsync = createAsync(body => {
  return async function getCompanyPayoutMethods(options) {
    const resp = await api.Payment.getCompanyPayoutMethods(body, options);
    return resp;
  };
});
const putPayoutMethodsAsync = createAsync(body => {
  return async function putPayoutMethods(options) {
    const resp = await api.Payment.putPayoutMethods(body, options);
    return resp;
  };
});
const postCompanyPayoutMethodAsync = createAsync(body => {
  return async function postCompanyPayoutMethod(options) {
    const resp = await api.Payment.postCompanyPayoutMethod(body, options);
    return resp;
  };
});
const assignCompanyPayoutMethodToPropertyAsync = createAsync(body => {
  return async function assignCompanyPayoutMethodToProperty(options) {
    const resp = await api.Payment.assignCompanyPayoutMethodToProperty(body, options);
    return resp;
  };
});
const getResidencyFeeAsync = createAsync(body => {
  return async function getResidencyFee(options) {
    const resp = await api.Payment.getResidencyFees(body, options);
    return resp;
  };
});
const updateResidencyFeeAsync = createAsync(body => {
  return async function updateResidencyFees(options) {
    const resp = await api.Payment.updateResidencyFees(body, options);
    return resp;
  };
});
const getResidentAccountTransactionHistoryV2Async = createAsync(data => {
  return async function getResidentTransactionHistoryV2(options) {
    const resp = await api.Payment.getResidentAccountTransactionHistory(data, options);
    return resp;
  };
});
const getTransactionHistoryV2ListingAsync = createAsync(data => {
  return async function getTransactionHistoryV2Listing(options) {
    const resp = await api.Payment.getTransactionHistoryV2Listing(data, options);
    const _getParent1 = getParent(this),
      statement = _getParent1.statement;
    statement.assignVoidedTransactionDataAfterLoad(resp);
    return resp;
  };
});

// ! check if this is used
const getResidentStatementByAccountAsync = createAsync(data => {
  return async function getResidentStatementByAccount(options) {
    const resp = await api.Statement.getAccountStatement(data, options);
    const _getParent10 = getParent(this),
      payment = _getParent10.payment;
    payment.assignResidentStatements(resp, data.month);
    return resp;
  };
});
const getStripeProductAsync = createAsync(data => {
  return async function getStripeProduct(options) {
    const resp = await api.Payment.getStripeProduct(data, options);
    return resp;
  };
});
const getAutopayMethodByAccountIdAsync = createAsync(data => {
  return async function getAutopayMethodByAccountId(options) {
    if (getParent(this).account.userProfile.isDemoModeEnabled) return null;
    const resp = await api.Payment.getAutopayMethodByAccountId(data, options);
    this.setAccountAutoPay(resp.response);
    return resp;
  };
});
const sendBalanceRemainderAsync = createAsync(body => {
  return async function sendBalanceRemainder(options) {
    const resp = await api.Payment.sendBalanceRemainder(body, options);
    return resp;
  };
});
const sendBalanceRemainderToMultipleAccountsAsync = createAsync(body => {
  return async function sendBalanceRemainderToMultipleAccounts(options) {
    const resp = await api.Payment.sendBalanceRemainderToMultipleAccounts(body, options);
    return resp;
  };
});
const getPropertyPaymentMethodAsync = createAsync(body => {
  return async function getPropertyPaymentMethod(options) {
    const applyToHomeDashboard = body.applyToHomeDashboard;
    delete body.applyToHomeDashboard;
    const resp = await api.Payment.getPropertyPaymentMethod(body, options);
    if (applyToHomeDashboard) {
      var _resp$response;
      const paymentSetup = selectedPropertyPaymentSetup(this);
      paymentSetup === null || paymentSetup === void 0 || paymentSetup.setPropertyPaymentMethod(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.paymentMethodId);
      paymentSetup === null || paymentSetup === void 0 || paymentSetup.setPropertyPaymentMethodData(resp === null || resp === void 0 ? void 0 : resp.response);
    }
    return resp;
  };
});
const setPropertyPaymentMethodAsync = createAsync(body => {
  return async function setPropertyPaymentMethod(options) {
    const resp = await api.Payment.setPropertyPaymentMethod(body, options);
    return resp;
  };
});
const createSetupIntentWithPaymentMethodReplacementAsync = createAsync(body => {
  return async function createSetupIntentWithPaymentMethodReplacement(options) {
    const resp = await api.Payment.createSetupIntentWithPaymentMethodReplacement(body, options);
    return resp;
  };
});
const getUsersPaperUsageAsync = createAsync(() => {
  return async function getUsersPaperUsage(options) {
    const resp = await api.Payment.getUsersPaperUsage(options);
    this.setUsersPaperUsage(resp.response);
    return resp;
  };
});
const getBillingScheduleAsync = createAsync(() => {
  return async function getUsersPaperUsage(options) {
    const resp = await api.Payment.getBillingSchedule(options);
    const _getParent11 = getParent(this),
      payment = _getParent11.payment;
    payment.setBillingSchedule(resp);
    return resp;
  };
});
const getResidentPaymentSettingsAsync = createAsync(data => {
  return async function getResidentPaymentSettings(options) {
    const resp = await api.Payment.getResidentPaymentSettings(data, options);
    return resp;
  };
});
const putResidentPaymentSettingsAsync = createAsync(data => {
  return async function putResidentPaymentSettings(options) {
    const resp = await api.Payment.putResidentPaymentSettings(data, options);
    return resp;
  };
});
const getStripeSubscriptionAsync = createAsync(data => {
  return async function getStripeSubscription(options) {
    const resp = await api.Payment.getStripeSubscription(data, options);
    if (resp !== null && resp !== void 0 && resp.response) this.setStripeSubscriptionUnits(resp === null || resp === void 0 ? void 0 : resp.response);
    return resp;
  };
});
const getStripeInvoiceAsync = createAsync(data => {
  return async function getStripeInvoice(options) {
    const resp = await api.Payment.getStripeInvoice(data, options);
    if (resp !== null && resp !== void 0 && resp.response) this.setStripeInvoices(resp === null || resp === void 0 ? void 0 : resp.response);
    return resp;
  };
});
const postRefundOrCreditAsync = createAsync(data => {
  return async function postRefundOrCredit(options) {
    const resp = await api.Payment.postRefundOrCredit(data, options);
    return resp;
  };
});
const postUndoRefundAsync = createAsync(data => {
  return async function postUndoRefund(options) {
    const resp = await api.Payment.postUndoRefund(data, options);
    return resp;
  };
});
const StripeSubscriptionProperty = types.model('StripeSubscriptionProperty', {
  unitsCount: types.maybeNull(types.number),
  propertyName: types.maybeNull(types.string)
});
const StripeSubscriptionUnit = types.model('StripeSubscriptionUnit', {
  last4: types.maybeNull(types.string),
  brand: types.maybeNull(types.string),
  properties: types.maybeNull(types.array(StripeSubscriptionProperty)),
  propertiesCount: types.maybeNull(types.number),
  subscriptionId: types.maybeNull(types.string),
  stripeSubscriptionId: types.maybeNull(types.string),
  subscriptionName: types.maybeNull(types.string),
  unitsCount: types.maybeNull(types.number)
});
const BillingSchedule = types.model('BillingSchedule', {
  billingScheduleEvent: types.string,
  remainingDays: types.number,
  toBeAppliedOnDateOnly: types.string
});
const Coupon = types.model('Coupon', {
  amount: types.optional(types.number, 0),
  amountType: types.union(types.literal(AMOUNT_TYPE.percentage), types.literal(AMOUNT_TYPE.fixedAmount)),
  appliedToProducts: types.maybeNull(types.array(types.string)),
  effectiveToDateOnly: types.maybeNull(types.string),
  effectiveToDateTimeUtc: types.maybeNull(types.string),
  stripeCouponId: types.optional(types.string, '')
});
const PaymentMethod = types.model('PaymentMethod', {
  brand: types.string,
  id: types.string,
  isVerified: types.boolean,
  isDefault: types.boolean,
  last4: types.string,
  paymentMethodType: types.maybeNull(types.string),
  assignedPropertyIds: types.maybeNull(types.array(types.string)),
  verificationDaysLeft: types.maybeNull(types.number),
  verificationUrl: types.maybeNull(types.string),
  isFailed: types.optional(types.boolean, false)
});
const PaymentSummary = types.model('PaymentSummary', {
  nextPaymentOn: types.maybeNull(types.string),
  total: types.number
});
const Subscription = types.model('Subscription', {
  amount: types.number,
  subscriptionId: types.string,
  subscriptionName: types.maybeNull(types.string)
});
const ResidentBalance = types.model({
  currentBalance: types.string,
  currentCharges: types.string,
  dueOnDateOnly: types.string,
  finalStatementMonth: types.string,
  finalStatementYear: types.string,
  hasFinalStatement: types.boolean,
  lastPaymentReceivedAtDateOnly: types.string,
  previousStatementBalance: types.string,
  previousStatementMonth: types.string,
  previousStatementPayments: types.string,
  previousStatementYear: types.string,
  balance: types.string,
  payments: types.string
});
const ResidentBalanceInitialData = {
  currentBalance: '00.00',
  currentCharges: '00.00',
  dueOnDateOnly: 'xx/xx/xxxx',
  finalStatementMonth: '0',
  finalStatementYear: '0',
  hasFinalStatement: false,
  lastPaymentReceivedAtDateOnly: 'MMM, YYYY',
  previousStatementBalance: '00.00',
  previousStatementMonth: '0',
  previousStatementYear: '0',
  previousStatementPayments: '00.00',
  balance: '00.00',
  payments: 'xxx'
};
const ItemMetadata = types.model({
  title: types.maybeNull(types.string),
  voidedTransactionId: types.maybeNull(types.string),
  voidedPaperStatementId: types.maybeNull(types.string),
  serviceStartDateOnly: types.maybeNull(types.string),
  serviceEndDateOnly: types.maybeNull(types.string),
  utilityId: types.maybeNull(types.string),
  utility: types.maybeNull(types.string),
  utilityTypeId: types.maybeNull(types.string),
  feeType: types.maybeNull(types.string),
  utilityTypeName: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  reason: types.maybeNull(types.string),
  paperStatementId: types.maybeNull(types.string),
  paperStatementYear: types.maybeNull(types.string),
  paperStatementMonth: types.maybeNull(types.string)
});
const residentStatementChargeItemBase = types.model({
  id: types.optional(types.string, ''),
  amount: types.maybeNull(types.number),
  billingCycleId: types.maybeNull(types.string),
  endDateOnly: types.maybeNull(types.string),
  startDateOnly: types.maybeNull(types.string),
  utilityId: types.optional(types.string, ''),
  utility: types.optional(types.string, ''),
  utilityTypeId: types.optional(types.string, ''),
  utilityTypeName: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  title: types.optional(types.string, ''),
  isSkipped: types.optional(types.boolean, false),
  isOptOut: types.optional(types.boolean, false),
  financialTransactionId: types.maybeNull(types.string),
  metadata: types.optional(ItemMetadata, {})
});
const residentStatementChargeItem = types.model({
  id: types.optional(types.string, ''),
  amount: types.maybeNull(types.number),
  billingCycleId: types.maybeNull(types.string),
  endDateOnly: types.maybeNull(types.string),
  startDateOnly: types.maybeNull(types.string),
  utilityId: types.optional(types.string, ''),
  utility: types.optional(types.string, ''),
  utilityTypeId: types.optional(types.string, ''),
  utilityTypeName: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  title: types.optional(types.string, ''),
  isSkipped: types.optional(types.boolean, false),
  isOptOut: types.optional(types.boolean, false),
  financialTransactionId: types.maybeNull(types.string),
  metadata: types.optional(ItemMetadata, {}),
  relatedTransactionData: types.maybeNull(residentStatementChargeItemBase)
});
const residentStatementChargesItem = types.model({
  charges: types.optional(types.array(residentStatementChargeItem), []),
  total: types.optional(types.number, 0),
  title: types.optional(types.string, ''),
  subTitle: types.optional(types.string, '')
});
const residentStatements = types.model({
  total: types.optional(types.number, 0),
  fileId: types.optional(types.string, ''),
  isFinalStatementValue: types.optional(types.boolean, false),
  utilityCharges: types.optional(residentStatementChargesItem, {}),
  delayedCharges: types.optional(residentStatementChargesItem, {}),
  otherCharges: types.optional(residentStatementChargesItem, {}),
  statementCharges: types.optional(residentStatementChargesItem, {}),
  statementCredits: types.optional(residentStatementChargesItem, {})
});
const utilityInfo = types.model({
  utilityId: types.string,
  utilityTypeId: types.string,
  utilityTypeName: types.string
});
const UsersPaperUsageUnit = types.model({
  amount: types.maybeNull(types.number),
  count: types.number
});
const UsersPaperUsage = types.model({
  paperInvitations: UsersPaperUsageUnit,
  paperStatements: UsersPaperUsageUnit
});
const StripeProduct = types.model({
  name: types.maybeNull(types.string),
  defaultAmount: types.maybeNull(types.number),
  feeUnitType: types.maybeNull(types.string),
  description: types.maybeNull(types.string)
});
const StripeInvoicesUnitLineItems = types.model({
  stripeLineItemId: types.maybeNull(types.string),
  productName: types.maybeNull(types.string),
  price: types.maybeNull(types.number),
  quantity: types.maybeNull(types.number),
  amountPaid: types.maybeNull(types.number),
  refunded: types.maybeNull(types.number),
  credit: types.maybeNull(types.number),
  remainingBalance: types.maybeNull(types.number)
});
const StripeInvoicesUnitRefundHistory = types.model({
  stripeRefundId: types.maybeNull(types.string),
  brand: types.maybeNull(types.string),
  last4: types.maybeNull(types.string),
  dateTime: types.maybeNull(types.string),
  amount: types.maybeNull(types.number),
  comment: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  refundCreditReason: types.maybeNull(types.string)
});
const StripeInvoicesUnit = types.model({
  id: types.maybeNull(types.string),
  invoiceNumber: types.maybeNull(types.string),
  type: types.maybeNull(types.string),
  description: types.maybeNull(types.string),
  last4: types.maybeNull(types.string),
  brand: types.maybeNull(types.string),
  paidAt: types.maybeNull(types.string),
  status: types.maybeNull(types.string),
  amount: types.maybeNull(types.number),
  adjustments: types.maybeNull(types.number),
  remainingBalance: types.maybeNull(types.number),
  amountPaid: types.maybeNull(types.number),
  remainingAmount: types.maybeNull(types.number),
  invoiceLink: types.maybeNull(types.string),
  stripeInvoiceId: types.maybeNull(types.string),
  paymentMethodId: types.maybeNull(types.string),
  stripeSubscriptionId: types.maybeNull(types.string),
  stripeRefundId: types.maybeNull(types.string),
  lineItems: types.maybeNull(types.array(StripeInvoicesUnitLineItems)),
  refundHistory: types.maybeNull(types.array(StripeInvoicesUnitRefundHistory))
});
const getTitle = (isFS, month) => {
  if (isFS) return "Utility charges for Final statement";
  return "Utility charges for ".concat(month, " billing period");
};
const getStatementChargesTitle = (isFS, month) => {
  if (isFS) return "Charges for Final statement";
  return "Charges for ".concat(month, " billing period");
};
const PaymentStore = types.model('PaymentStore', {
  autopayMethodValue: types.maybeNull(types.optional(PaymentMethod, {
    brand: '',
    id: '',
    isVerified: false,
    isDefault: false,
    last4: '',
    paymentMethodType: '',
    verificationDaysLeft: null,
    verificationUrl: ''
  })),
  applyCouponAsync,
  billingScheduleValue: types.optional(types.array(BillingSchedule), []),
  couponsValue: types.optional(types.array(Coupon), []),
  getAccountBalanceAsync,
  deletePaymentMethodAsync,
  getAutopayMethodAsync,
  setAutopayMethodAsync,
  getCouponsAsync,
  getPaymentMethodsAsync,
  getPaymentMethodsV2Async,
  getPaymentMethodsHomeDashboardAsync,
  getPaymentSummaryAsync,
  getPublicKeyAsync,
  getSetupIntentAsync,
  getSetupIntentWithAutopayAsync,
  getSetupIntentWithSubscriptionAsync,
  getSubscriptionAsync,
  sendBalanceRemainderAsync,
  getPropertyPaymentMethodAsync,
  setPropertyPaymentMethodAsync,
  postPayoutAchDirectDepositAsync,
  postSetupIntentWithCouponAsync,
  putPayoutAchDirectDepositAsync,
  getPayoutAchDirectDepositAsync,
  getCompanyAchDirectDepositsListAsync,
  postPayoutRegularCheckAsync,
  putPayoutRegularCheckAsync,
  getPayoutRegularCheckAsync,
  getAutopayMethodByAccountIdAsync,
  getCompanyPayoutRegularChecksListAsync,
  getResidencyFeeAsync,
  getResidentAccountTransactionHistoryV2Async,
  getTransactionHistoryV2ListingAsync,
  sendBalanceRemainderToMultipleAccountsAsync,
  createSetupIntentWithPaymentMethodReplacementAsync,
  getResidentStatementByAccountAsync,
  getStripeProductAsync,
  getUsersPaperUsageAsync,
  getStripeProductsAsync,
  getCompanyPayoutMethodsAsync,
  postCompanyPayoutMethodAsync,
  putPayoutMethodsAsync,
  assignCompanyPayoutMethodToPropertyAsync,
  invoiceDoesNotExistError: types.optional(types.boolean, false),
  methodAddedValue: types.optional(types.boolean, false),
  paymentMethodsValues: types.optional(types.array(PaymentMethod), []),
  stripeProducts: types.optional(types.array(StripeProduct), []),
  usersPaperUsage: types.optional(UsersPaperUsage, {
    paperInvitations: {
      amount: 0,
      count: 0
    },
    paperStatements: {
      amount: 0,
      count: 0
    }
  }),
  paymentSummaryValue: types.optional(PaymentSummary, {
    nextPaymentOn: '',
    total: 0
  }),
  publicKeyValue: types.optional(types.string, ''),
  stripeSetupIntentIdValue: types.optional(types.string, ''),
  subscriptionValue: types.optional(Subscription, {
    amount: 0,
    subscriptionId: '',
    subscriptionName: 'Unit Subscription Fee'
  }),
  residentBalance: types.optional(ResidentBalance, ResidentBalanceInitialData),
  residentStatements: types.optional(residentStatements, {}),
  statementIdValue: types.optional(types.string, ''),
  utilityInfos: types.optional(types.array(utilityInfo), []),
  isAccountAutoPay: types.optional(types.boolean, false),
  isVoidedValue: types.optional(types.boolean, false),
  updateResidencyFeeAsync,
  getBillingScheduleAsync,
  getResidentPaymentSettingsAsync,
  putResidentPaymentSettingsAsync,
  getStripeSubscriptionAsync,
  getStripeInvoiceAsync,
  postRefundOrCreditAsync,
  postUndoRefundAsync,
  stripeSubscriptionUnits: types.optional(types.array(StripeSubscriptionUnit), []),
  stripeInvoices: types.optional(types.array(StripeInvoicesUnit), [])
}).actions(store => {
  return {
    setAutopayMethodAfterLoad(data) {
      try {
        store.autopayMethodValue = data.response;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setAccountAutoPay(data) {
      try {
        store.isAccountAutoPay = !!data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setStripeInvoices(data) {
      try {
        store.stripeInvoices = cast(data.sort((a, b) => moment(b.paidAt).diff(moment(a.paidAt))).sort((a, b) => a.status === 'Upcoming' ? -1 : b.status === 'Upcoming' ? 1 : 0).map(i => _objectSpread(_objectSpread({}, i), {}, {
          refundHistory: i.refundHistory.sort((a, b) => moment(b.dateTime).diff(moment(a.dateTime)))
        })));
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    getCurrentStripeInvoices(id) {
      const activeStripeInvoices = store.stripeInvoices.find(i => i.id === id);
      return activeStripeInvoices;
    },
    getCurrentStripeInvoicesByRefundId(id) {
      const activeStripeInvoices = store.stripeInvoices.find(i => i.stripeRefundId === id);
      return activeStripeInvoices;
    },
    getCurrentStripeSubscription(id) {
      const activeStripeSubscription = store.stripeSubscriptionUnits.find(i => i.subscriptionId === id);
      return activeStripeSubscription;
    },
    setStripeSubscriptionUnits(data) {
      try {
        store.stripeSubscriptionUnits = cast(data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setBillingSchedule(resp) {
      try {
        store.billingScheduleValue = cast(resp.response);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setStripeProducts(data) {
      try {
        store.stripeProducts = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setCouponsAfterLoad(data) {
      try {
        store.couponsValue = cast(data.response);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPaymentMethodsAfterLoad(data) {
      try {
        store.paymentMethodsValues = data.response;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetPaymentMethods() {
      try {
        store.paymentMethodsValues = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setUsersPaperUsage(data) {
      try {
        store.usersPaperUsage = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPaymentSummaryAfterLoad(data) {
      try {
        if (data.Error && data.Error.ErrorCode === 'InvoiceDoesNotExist') store.invoiceDoesNotExistError = true;else {
          store.invoiceDoesNotExistError = false;
          store.paymentSummaryValue = _objectSpread({}, data.response);
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setMethodAdded(data) {
      try {
        store.methodAddedValue = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setPublicKeyAfterLoad(data) {
      try {
        store.publicKeyValue = data.response;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setSetupIntentId(data) {
      try {
        store.stripeSetupIntentIdValue = data.response.stripeSetupIntentId;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setSubscriptionAfterLoad(data) {
      try {
        store.subscriptionValue = data.response[0];
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    updatePaymentMethodsAfterDelete(data) {
      try {
        applySnapshot(store, _objectSpread(_objectSpread({}, store), {}, {
          paymentMethodsValues: store.paymentMethodsValues.filter(p => p.id !== data.paymentMethodId)
        }));
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setResidentBalance(data) {
      try {
        data.lastPaymentReceivedAtDateOnly = moment().month(data.previousStatementMonth - 1).year(data.previousStatementYear).format('MMM, YYYY');
        Object.keys(data).forEach(key => {
          if (key === 'hasFinalStatement') store.residentBalance[key] = data[key];else store.residentBalance[key] = "".concat(data[key]);
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setDueOnDateOnly(data) {
      try {
        if (!store.residentBalance.dueOnDateOnly || store.residentBalance.dueOnDateOnly === ResidentBalanceInitialData.dueOnDateOnly) {
          store.residentBalance.dueOnDateOnly = moment(data.response.dueDate).format('MM/DD/YYYY');
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    assignResidentStatements(data, month) {
      try {
        const monthName = moment().month(month).format('MMMM');
        store.residentStatements = cast({});
        if (data.isSuccessful) {
          if (!data.response) return;
          const _data$response = data.response,
            id = _data$response.id,
            isFinalStatement = _data$response.isFinalStatement,
            isVoided = _data$response.isVoided,
            total = _data$response.total,
            utilityCharges = _data$response.utilityCharges,
            delayedCharges = _data$response.delayedCharges,
            otherCharges = _data$response.otherCharges,
            fileId = _data$response.fileId,
            statementCharges = _data$response.statementCharges,
            statementCredits = _data$response.statementCredits;
          store.isVoidedValue = isVoided;
          store.residentStatements.fileId = fileId;
          store.residentStatements.isFinalStatementValue = isFinalStatement;
          store.residentStatements.total = total;
          store.residentStatements.utilityCharges.title = getTitle(isFinalStatement, monthName);
          store.residentStatements.utilityCharges.subTitle = '';
          store.residentStatements.utilityCharges.total = utilityCharges.total;
          store.residentStatements.utilityCharges.charges.push(...utilityCharges.charges.map(charge => {
            if (charge.amount < 0) {
              charge.type = 'credit';
              charge.amount = charge.amount * -1;
            }
            return charge;
          }));
          store.residentStatements.delayedCharges.title = 'Delayed charges';
          store.residentStatements.delayedCharges.subTitle = 'Note: Delayed charges are coming from bills that were skipped the previous month(s). If you have questions or thinks there is a mistake contact your property manager.';
          store.residentStatements.delayedCharges.total = delayedCharges.total;
          store.residentStatements.delayedCharges.charges.push(...delayedCharges.charges);
          store.residentStatements.otherCharges.title = 'Other charges and credits';
          store.residentStatements.otherCharges.subTitle = '';
          store.residentStatements.otherCharges.total = otherCharges.total;
          store.residentStatements.otherCharges.charges.push(...otherCharges.charges.reduce((acc, item) => {
            var _item$metadata, _item$metadata2;
            if (item.utilityId === null) item.utilityId = uuid();
            if (item !== null && item !== void 0 && (_item$metadata = item.metadata) !== null && _item$metadata !== void 0 && _item$metadata.title) item.title = item === null || item === void 0 || (_item$metadata2 = item.metadata) === null || _item$metadata2 === void 0 ? void 0 : _item$metadata2.title;
            return [...acc, item];
          }, []));
          store.residentStatements.statementCharges.title = getStatementChargesTitle(isFinalStatement, monthName);
          store.residentStatements.statementCharges.subTitle = '';
          store.residentStatements.statementCharges.total = statementCharges.total;
          store.residentStatements.statementCharges.charges.push(...statementCharges.items.reduce((acc, item) => {
            var _item$metadata3, _item$metadata4;
            if (item.utilityId === null) item.utilityId = uuid();
            if (item !== null && item !== void 0 && (_item$metadata3 = item.metadata) !== null && _item$metadata3 !== void 0 && _item$metadata3.title) item.title = item === null || item === void 0 || (_item$metadata4 = item.metadata) === null || _item$metadata4 === void 0 ? void 0 : _item$metadata4.title;
            return [...acc, item];
          }, []));
          store.residentStatements.statementCredits.title = 'Credits';
          store.residentStatements.statementCredits.subTitle = '';
          store.residentStatements.statementCredits.total = statementCredits.total;
          store.residentStatements.statementCredits.charges.push(...statementCredits.items.reduce((acc, item) => {
            var _item$metadata5, _item$metadata6;
            if (item.utilityId === null) item.utilityId = uuid();
            if (item !== null && item !== void 0 && (_item$metadata5 = item.metadata) !== null && _item$metadata5 !== void 0 && _item$metadata5.title) item.title = item === null || item === void 0 || (_item$metadata6 = item.metadata) === null || _item$metadata6 === void 0 ? void 0 : _item$metadata6.title;
            return [...acc, item];
          }, []));
          store.statementIdValue = id;
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    assignResidentSkippedStatement(data, chargesType) {
      try {
        store.residentStatements[chargesType].charges.push(...data);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setUtilityInfo(data) {
      try {
        const isSuccessful = data.isSuccessful,
          utilities = data.response.utilities;
        if (isSuccessful) {
          applySnapshot(store, _objectSpread(_objectSpread({}, store), {}, {
            utilityInfos: [...utilities]
          }));
          const utilityInfosLocal = [...toJS(store.utilityInfos), ...utilities];
          ['utilityCharges', 'delayedCharges', 'otherCharges', 'statementCharges', 'statementCredits'].forEach(chargeType => {
            store.residentStatements["".concat(chargeType)].charges.forEach((i, index) => {
              const applicableInfo = utilityInfosLocal.find(info => info.utilityId === i.utilityId);
              store.residentStatements["".concat(chargeType)].charges[index].billingCycleId = i.billingCycleId;
              if (applicableInfo) {
                store.residentStatements["".concat(chargeType)].charges[index].utilityTypeId = applicableInfo === null || applicableInfo === void 0 ? void 0 : applicableInfo.utilityTypeId;
                store.residentStatements["".concat(chargeType)].charges[index].utilityTypeName = applicableInfo === null || applicableInfo === void 0 ? void 0 : applicableInfo.utilityTypeName;
              }
              if (i.type === TRANSACTION_TYPESV2.Void) {
                const applicableInfoForVoid = utilityInfosLocal.find(info => info.utilityId === store.residentStatements["".concat(chargeType)].charges[index].relatedTransactionData.utilityId);
                if (applicableInfoForVoid) {
                  store.residentStatements["".concat(chargeType)].charges[index].relatedTransactionData.utilityTypeId = applicableInfoForVoid === null || applicableInfoForVoid === void 0 ? void 0 : applicableInfoForVoid.utilityTypeId;
                  store.residentStatements["".concat(chargeType)].charges[index].relatedTransactionData.utilityTypeName = applicableInfoForVoid === null || applicableInfoForVoid === void 0 ? void 0 : applicableInfoForVoid.utilityTypeName;
                }
              }
            });
          });
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setVoidedAdditionalInfo(data) {
      try {
        ['statementCharges', 'statementCredits'].forEach(chargeType => {
          store.residentStatements["".concat(chargeType)].charges.forEach((charge, index) => {
            var _charge$metadata;
            if ((charge === null || charge === void 0 ? void 0 : charge.type) === TRANSACTION_TYPESV2.Void && data.map(i => i.id).includes(charge === null || charge === void 0 || (_charge$metadata = charge.metadata) === null || _charge$metadata === void 0 ? void 0 : _charge$metadata.voidedTransactionId)) {
              const indexF = data.findIndex(i => {
                var _charge$metadata2;
                return (i === null || i === void 0 ? void 0 : i.id) === (charge === null || charge === void 0 || (_charge$metadata2 = charge.metadata) === null || _charge$metadata2 === void 0 ? void 0 : _charge$metadata2.voidedTransactionId);
              });
              if (indexF !== -1) {
                const result = _objectSpread(_objectSpread({}, data[indexF]), {}, {
                  type: data[indexF].transactionType,
                  utilityId: data[indexF].metadata.utilityId
                });
                store.residentStatements["".concat(chargeType)].charges[index].relatedTransactionData = result;
              }
            }
          });
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
}).views(store => ({
  get autopayMethod() {
    return store.autopayMethodValue;
  },
  get billingSchedule() {
    return store.billingScheduleValue;
  },
  get coupons() {
    return store.couponsValue;
  },
  get hasPaymentMethod() {
    return store.paymentMethodsValues.length > 0 || store.methodAddedValue;
  },
  get isFinalStatement() {
    return store.residentStatements.isFinalStatementValue;
  },
  get isVoided() {
    return store.isVoidedValue;
  },
  get invoiceDoesNotExist() {
    return store.invoiceDoesNotExistError;
  },
  get methodAdded() {
    return store.methodAddedValue;
  },
  get paymentMethods() {
    return store.paymentMethodsValues;
  },
  get failedPaymentMethods() {
    return store.paymentMethodsValues.find(i => !!i.isFailed);
  },
  get warningPaymentMethods() {
    return store.paymentMethodsValues.find(i => !i.isVerified && !i.isFailed);
  },
  get paymentSummary() {
    return store.paymentSummaryValue;
  },
  get publicKey() {
    return store.publicKeyValue;
  },
  get statementId() {
    return store.statementIdValue;
  },
  get stripeSetupIntentId() {
    return store.stripeSetupIntentIdValue;
  },
  get subscription() {
    return store.subscriptionValue;
  },
  get subscriptionName() {
    return store.subscriptionValue.subscriptionName;
  },
  get getUtilityCharges() {
    return store.residentStatements.utilityCharges;
  },
  get getDelayedCharges() {
    return store.residentStatements.delayedCharges;
  },
  get getOtherCharges() {
    return store.residentStatements.otherCharges;
  },
  get getStatementCharges() {
    return store.residentStatements.statementCharges;
  },
  get getStatementCredits() {
    return store.residentStatements.statementCredits;
  },
  get getUtilityInfo() {
    return store.utilityInfos;
  }
}));
export const payment = types.optional(PaymentStore, {});